const dropzoneLoader = {
  name: "dropzone",
  load: () => import(/* webpackChunkName: "dropzone" */ "dropzone").then(module => module.default)
};

const vimeoLoader = {
  name: "vimeo",
  load: () => import(/* webpackChunkName: "vimeo" */ "@vimeo/player").then(module => module.default)
};

const priceSliderLoader = {
  name: "price-slider",
  load: () =>
    import(
      /* webpackChunkName: "price-slider" */ "components/jiffy/price-slider/price-slider"
    ).then(module => module.default)
};

const cropperJs = {
  name: "cropperjs",
  load: () => import(/* webpackChunkName: "cropperjs" */ "cropperjs").then(module => module.default)
};

const sortableJs = {
  name: "sortablejs",
  load: () =>
    import(/* webpackChunkName: "sortablejs" */ "sortablejs").then(module => module.default)
};

const choicesJs = {
  name: "choicesjs",
  load: () =>
    import(/* webpackChunkName: "choicesjs" */ "choices.js").then(module => module.default)
};

const flickityAsNavFor = {
  name: "flickity-as-nav-for",
  load: () =>
    import(/* webpackChunkName: "flickity-as-nav-for" */ "flickity-as-nav-for").then(
      module => module.default
    )
};

const loaders = [
  dropzoneLoader,
  vimeoLoader,
  priceSliderLoader,
  cropperJs,
  sortableJs,
  flickityAsNavFor,
  choicesJs
];

// eslint-disable-next-line import/prefer-default-export
export const loadPackage = name => {
  const packageLoader = loaders.find(loader => loader.name === name);
  if (!packageLoader) return Promise.reject(new Error(`Module "${name}" is not found.`));
  return packageLoader.load();
};
